import { ReactElement } from "react";
import { Box } from "@mui/material";


interface IProps {
  title: string;
  value: any;
  color: string | ((value: any) => string);
}

const HeaderValue = ({ title, value, color }: IProps): ReactElement => {
  return (
    <Box className="display-grid border-rounded-2 scroll-hidden" style={{ gridTemplateColumns: "1fr", gridTemplateRows: "auto auto", justifyItems: "stretch" }}>
      <div className="display-grid justify-content-center scroll-hidden" style={{ background: "rgba(127, 127, 127, .5)" }} >
        <strong>{title}</strong>
      </div>
      <div className="display-grid justify-content-center" >
        <strong style={{ color: typeof color === "string" ? color : color(value), fontSize: "1.5em" }}>{value}</strong>
      </div>
    </Box>
  );
};

export default HeaderValue;
